<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Contact' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group" *ngIf="entity.firstName">
      <label class="font-weight-bold">{{'Name' | translate}}</label>
      <p>{{entity.firstName}} {{entity.lastName}}</p>
    </div>

    <div class="form-group" *ngIf="entity.emailAddress">
      <label class="font-weight-bold">{{'Email address' | translate}}</label>
      <p>{{entity.emailAddress}}</p>
    </div>

    <div class="form-group" *ngIf="entity.phoneNumber">
      <label class="font-weight-bold">{{'Phone number' | translate}}</label>
     <p>
       {{entity.phoneNumber}}
     </p>
    </div>

    <div class="form-group" *ngIf="entity.homeAddress">
      <label class="font-weight-bold">{{'Address' | translate}}</label>
      <p>
        {{entity.homeAddress.street}}, {{entity.homeAddress.number}}{{entity.homeAddress.numberSuffix ? '-' + entity.homeAddress.numberSuffix : ''}}, {{entity.homeAddress.city}}, {{entity.homeAddress.postalCode}}, {{locale.getCountryName(entity.homeAddress.country)}}
      </p>
    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-outline-secondary ml-auto mr-0" (click)="activeModal.close(false)">{{'Close' | translate}}</button>
    </div>
  </div>
</div>

